export class Campaign3 {
    id?: number; 
    code?: string;
    name: string;
    campaign_type_id?: number; 
    campaign_type_description?: string;
    description: string; 
    start_date: string; 
    end_date: string;
    start_frution_date?: string; 
    end_frution_date?: string;
    budget: string;
    budget_type_id: number;
    priority: number;
    flg_pressure_rules: string;
    campaign_status_id:number;
}


// WEBPACK FOOTER //
// ./src/app/models/campaign3.model.ts